<template>
    <ATsagTeacherLessonsByTeacher
      :teacherRef="userProfile.ref.path"
      v-if="userProfile && userProfile.ref.path"
    ></ATsagTeacherLessonsByTeacher>
</template>
<script>
import { mapState } from "vuex";
import Vue from "vue";
const fb = require("../../firebaseConfig.js");

export default {
  data: () => ({}),

  components: {
    ATsagTeacherLessonsByTeacher: () =>
      import("./ATsagTeacherLessonsByTeacher.vue"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
};
</script>
 